import { useState } from 'react';
import { ColumnInfo, WebsiteColumnResult } from '../types/rankAList';

export const useRankAListState = () => {
  const [step, setStep] = useState(1);
  const [uploadId, setUploadId] = useState<string>('');
  const [uploadedFile, setUploadedFile] = useState<File | undefined>(undefined);
  const [totalRows, setTotalRows] = useState<number | undefined>(undefined);
  const [columns, setColumns] = useState<ColumnInfo[]>([]);
  const [websiteColumnResults, setWebsiteColumnResults] = useState<WebsiteColumnResult[]>([]);
  const [selectedWebsiteColumns, setSelectedWebsiteColumns] = useState<string[]>([]);
  const [searchForMissing, setSearchForMissing] = useState<boolean>(false);
  const [passthroughColumns, setPassthroughColumns] = useState<string[]>([]);
  const [approach, setApproach] = useState<'prediction' | 'similarity'>('prediction');
  const [labelColumn, setLabelColumn] = useState<string>('');
  const [availableLabels, setAvailableLabels] = useState<string[]>([]);
  const [positiveLabels, setPositiveLabels] = useState<string[]>([]);
  const [negativeLabels, setNegativeLabels] = useState<string[]>([]);
  const [jobId, setJobId] = useState<string>('');
  const [expandedSteps, setExpandedSteps] = useState<number[]>([1, 2, 3, 4, 5, 6, 7, 8]);

  return {
    step,
    setStep,
    uploadId,
    setUploadId,
    uploadedFile,
    setUploadedFile,
    totalRows,
    setTotalRows,
    columns,
    setColumns,
    websiteColumnResults,
    setWebsiteColumnResults,
    selectedWebsiteColumns,
    setSelectedWebsiteColumns,
    searchForMissing,
    setSearchForMissing,
    passthroughColumns,
    setPassthroughColumns,
    approach,
    setApproach,
    labelColumn,
    setLabelColumn,
    availableLabels,
    setAvailableLabels,
    positiveLabels,
    setPositiveLabels,
    negativeLabels,
    setNegativeLabels,
    jobId,
    setJobId,
    expandedSteps,
    setExpandedSteps,
  };
}; 